import { animate, keyframes, state, style, transition, trigger } from '@angular/animations';
import { Component } from '@angular/core';
import { Toast, ToastPackage, ToastrService } from 'ngx-toastr';
import { AircraftService } from '../core/services/aircraft.service';
import { CoreService } from '../core/services/core.service';

@Component({
  selector: '[error-toast-component]',
  styleUrls: ['./error-toast.component.less'],
  templateUrl: './error-toast.component.html',
  animations: [
    trigger('flyInOut', [
      state('inactive', style({
        display: 'none',
        opacity: 0
      })),
      transition('inactive => active', animate('400ms ease-out', keyframes([
        style({
          opacity: 0,
        }),
        style({
          opacity: 1,
        })
      ]))),
      transition('active => removed', animate('400ms ease-out', keyframes([
        style({
          opacity: 1,
        }),
        style({
          transform: 'translate3d(10%, 0, 0) skewX(10deg)',
          opacity: 0,
        }),
      ]))),
    ]),
  ],
  preserveWhitespaces: false,
})
export class ErrorToastComponent extends Toast {
  undoString = 'undo';
  public aircraft_id: any = [];
  selectedErrorToastStatus: number = 1;

  constructor(
    protected toastrService: ToastrService,
    public toastPackage: ToastPackage,
    private aircraftService: AircraftService,
    public coreservice: CoreService,
  ) { 
    super(toastrService, toastPackage);
    this.aircraft_id = this.coreservice.aircraft.aircraft_id;

  }

  action(event: Event) {
    event.stopPropagation();
    this.undoString = 'undid';
    this.toastPackage.triggerAction();
    return false;
  }
  
  checkboxSelected(e) {
    if(e.target.checked){  
      console.log("e.target.checked", e.target.checked);
      return this.aircraftService.msuUpgradeNotice(this.aircraft_id, e.target.checked, this.selectedErrorToastStatus).then(
        (res: any) => {
           if(res.body == true)
           {
             this.toastrService.clear(this.coreservice.errorToast.toastId);
           }
        }
      ); 
    }
 }
}
